import i18next from "i18next";
import { useLocation } from 'react-router-dom'
import PathToRegexp from "path-to-regexp";
import {ROUTE} from "./consts";
import {default_language, languages} from "./lang";

const GenerateURL = (url) => {
  const location = useLocation();
  const routeComponents = PathToRegexp(ROUTE).exec(location.pathname);
  let subPaths = null;
  if (routeComponents && routeComponents[2]) {
    if (routeComponents && routeComponents[1].length === 2 && languages.some(({code}) => code === i18next.language)) {
      return `${i18next.language === default_language ? '' : `/${i18next.language}`}${url === '/' ? '/' : url + '/'}`
    } else {
      return url === '/' ? '/' : url + '/';
    }
  } else if (routeComponents && routeComponents[1]) {
    subPaths = routeComponents[1].split("/");
    subPaths = subPaths[0].length === 2 ? routeComponents[1].split("/") : null;
    if (languages.some(({code}) => code === i18next.language)) {
      return subPaths ? `${i18next.language === default_language ? '' : `/${i18next.language}`}${url === '/' ? '/' : url + '/'}` : url === '/' ? '/' : url + '/';
    } else {
      return url === '/' ? '/' : url + '/';
    }
  } else {
    return url === '/' ? '/' : url + '/';
  }
};


export default GenerateURL;